import { checkIcon } from '@workday/canvas-system-icons-web'
import { createIcon } from './create-icon'
import { canvasIconPaths } from './canvasIconPaths'

export const Check = createIcon({
  displayName: 'Check',
  paths: [
    'M786.573 298.662c-10.923 0-21.845 4.181-30.208 12.501l-331.819 331.862-138.368-138.325c-8.32-8.363-19.243-12.501-30.208-12.501-10.88 0-21.803 4.139-30.165 12.501-16.64 16.64-16.64 43.648 0 60.331l153.6 153.557c12.459 12.459 28.8 18.688 45.141 18.688 16.299 0 32.64-6.229 45.099-18.688l347.093-347.094c16.64-16.683 16.64-43.648 0-60.331-8.32-8.32-19.243-12.501-30.165-12.501z'
  ],
  canvasPaths: canvasIconPaths(checkIcon)
})
